export default __webpack_public_path__ + "baseballcards_logo.6520b79a.svg";